import AlertIcon from "@/assets/svgs/alert-icon.svg";
import ArrowLeftIcon from "@/assets/svgs/arrow-left-icon.svg";
import ArrowRightIcon from "@/assets/svgs/arrow-right-icon.svg";
import ArrowRenewIcon from "@/assets/svgs/arrow-renew.svg";
import BackspaceIcon from "@/assets/svgs/backspace-icon.svg";
import BanIcon from "@/assets/svgs/ban-icon.svg";
import BirthdayIcon from "@/assets/svgs/birthday-icon.svg";
import BusinessIcon from "@/assets/svgs/business-icon.svg";
import CalendarIcon from "@/assets/svgs/calendar-icon.svg";
import AmexIcon from "@/assets/svgs/cc-amex-icon.svg";
import DinersClubIcon from "@/assets/svgs/cc-diners-icon.svg";
import DiscoverIcon from "@/assets/svgs/cc-discover-icon.svg";
import JcbIcon from "@/assets/svgs/cc-jcb-icon.svg";
import MastercardIcon from "@/assets/svgs/cc-mastercard-icon.svg";
import UnionPayIcon from "@/assets/svgs/cc-unionpay-icon.svg";
import VisaIcon from "@/assets/svgs/cc-visa-icon.svg";
import CardReaderIcon from "@/assets/svgs/card-reader-icon.svg";
import CheckIcon from "@/assets/svgs/check-icon.svg";
import ChevronDownIcon from "@/assets/svgs/chevron-down-icon.svg";
import ChevronLeftIcon from "@/assets/svgs/chevron-left-icon.svg";
import ChevronRightIcon from "@/assets/svgs/chevron-right-icon.svg";
import ChevronUpIcon from "@/assets/svgs/chevron-up-icon.svg";
import CombineIcon from "@/assets/svgs/combine-icon.svg";
import CommentIcon from "@/assets/svgs/comment.svg";
import CopyIcon from "@/assets/svgs/copy-icon.svg";
import CreditCardIcon from "@/assets/svgs/credit-card-icon.svg";
import DocumentIcon from "@/assets/svgs/document-icon.svg";
import DocumentLinesIcon from "@/assets/svgs/document-lines-icon.svg";
import DownloadIcon from "@/assets/svgs/download-icon.svg";
import EditIcon from "@/assets/svgs/edit-icon.svg";
import FilterIcon from "@/assets/svgs/filter-icon.svg";
import EyeIcon from "@/assets/svgs/eye-icon.svg";
import EyeSlashIcon from "@/assets/svgs/eye-slash-icon.svg";
import GiftIcon from "@/assets/svgs/gift-icon.svg";
import GraphIcon from "@/assets/svgs/graph-icon.svg";
import GridIcon from "@/assets/svgs/grid-icon.svg";
import HomeIcon from "@/assets/svgs/home-icon.svg";
import InfinityIcon from "@/assets/svgs/infinity-icon.svg";
import InformationIcon from "@/assets/svgs/information-icon.svg";
import JpgIcon from "@/assets/svgs/jpg-icon.svg";
import KeyIcon from "@/assets/svgs/key-icon.svg";
import ListIcon from "@/assets/svgs/list-icon.svg";
import LocationIcon from "@/assets/svgs/location-icon.svg";
import MailIcon from "@/assets/svgs/mail-icon.svg";
import MapIcon from "@/assets/svgs/map-icon.svg";
import MappingIcon from "@/assets/svgs/mapping-icon.svg";
import MenuIcon from "@/assets/svgs/menu-icon.svg";
import MinusIcon from "@/assets/svgs/minus-icon.svg";
import MoneyIcon from "@/assets/svgs/money-icon.svg";
import MoreVerticalIcon from "@/assets/svgs/more-vert.svg";
import MoreHorizontalIcon from "@/assets/svgs/more-horiz.svg";
import MsExcelIcon from "@/assets/svgs/ms-excel-icon.svg";
import MsPowerpointIcon from "@/assets/svgs/ms-powerpoint-icon.svg";
import MsWordIcon from "@/assets/svgs/ms-word-icon.svg";
import PdfIcon from "@/assets/svgs/pdf-icon.svg";
import PhoneIcon from "@/assets/svgs/phone-icon.svg";
import PillIcon from "@/assets/svgs/pill-icon.svg";
import PlayIcon from "@/assets/svgs/play-icon.svg";
import PlusIcon from "@/assets/svgs/plus-icon.svg";
import PlusMinusIcon from "@/assets/svgs/plus-minus-icon.svg";
import PngIcon from "@/assets/svgs/png-icon.svg";
import QrIcon from "@/assets/svgs/qr-icon.svg";
import QuestionIcon from "@/assets/svgs/question-icon.svg";
import ReportIcon from "@/assets/svgs/report-icon.svg";
import RxIcon from "@/assets/svgs/rx-icon.svg";
import SaveIcon from "@/assets/svgs/save-icon.svg";
import SearchIcon from "@/assets/svgs/search-icon.svg";
import SelectAllIcon from "@/assets/svgs/select-all-icon.svg";
import SendIcon from "@/assets/svgs/send-icon.svg";
import SettingsIcon from "@/assets/svgs/settings-icon.svg";
import ShoppingBagIcon from "@/assets/svgs/shopping-bag-icon.svg";
import SignOutIcon from "@/assets/svgs/sign-out-icon.svg";
import StarIcon from "@/assets/svgs/star-icon.svg";
import SupportIcon from "@/assets/svgs/support-icon.svg";
import TableIcon from "@/assets/svgs/table-icon.svg";
import TaskListIcon from "@/assets/svgs/task-list-icon.svg";
import TestTubeIcon from "@/assets/svgs/test-tube-icon.svg";
import ToolIcon from "@/assets/svgs/tool-icon.svg";
import TrainingIcon from "@/assets/svgs/training-icon.svg";
import TrashIcon from "@/assets/svgs/trash-icon.svg";
import UploadIcon from "@/assets/svgs/upload-icon.svg";
import UserCircleIcon from "@/assets/svgs/user-circle-icon.svg";
import UserIcon from "@/assets/svgs/user-icon.svg";
import UsersIcon from "@/assets/svgs/users-icon.svg";
import VideoIcon from "@/assets/svgs/video-icon.svg";
import XIcon from "@/assets/svgs/x-icon.svg";

export {
  AlertIcon,
  AmexIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowRenewIcon,
  BackspaceIcon,
  BanIcon,
  BirthdayIcon,
  BusinessIcon,
  CalendarIcon,
  CardReaderIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  CombineIcon,
  CommentIcon,
  CopyIcon,
  CreditCardIcon,
  DinersClubIcon,
  DiscoverIcon,
  DocumentIcon,
  DocumentLinesIcon,
  DownloadIcon,
  EditIcon,
  EyeIcon,
  EyeSlashIcon,
  FilterIcon,
  GiftIcon,
  GraphIcon,
  GridIcon,
  HomeIcon,
  InformationIcon,
  InfinityIcon,
  JcbIcon,
  JpgIcon,
  KeyIcon,
  ListIcon,
  LocationIcon,
  MailIcon,
  MapIcon,
  MappingIcon,
  MastercardIcon,
  MenuIcon,
  MinusIcon,
  MoneyIcon,
  MoreVerticalIcon,
  MoreHorizontalIcon,
  MsExcelIcon,
  MsPowerpointIcon,
  MsWordIcon,
  PdfIcon,
  PhoneIcon,
  PillIcon,
  PlayIcon,
  PlusIcon,
  PlusMinusIcon,
  PngIcon,
  QrIcon,
  QuestionIcon,
  ReportIcon,
  RxIcon,
  SaveIcon,
  SearchIcon,
  SelectAllIcon,
  SendIcon,
  SettingsIcon,
  ShoppingBagIcon,
  SignOutIcon,
  StarIcon,
  SupportIcon,
  TableIcon,
  TaskListIcon,
  TestTubeIcon,
  ToolIcon,
  TrainingIcon,
  TrashIcon,
  UnionPayIcon,
  UploadIcon,
  UserCircleIcon,
  UserIcon,
  UsersIcon,
  VideoIcon,
  VisaIcon,
  XIcon,
};
